function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/web.dom-collections.iterator.js";
import Cartesian3 from "terriajs-cesium/Source/Core/Cartesian3";
import TimeIntervalCollection from "terriajs-cesium/Source/Core/TimeIntervalCollection";
import BillboardGraphics from "terriajs-cesium/Source/DataSources/BillboardGraphics";
import ConstantPositionProperty from "terriajs-cesium/Source/DataSources/ConstantPositionProperty";
import LabelGraphics from "terriajs-cesium/Source/DataSources/LabelGraphics";
import PointGraphics from "terriajs-cesium/Source/DataSources/PointGraphics";
import PropertyBag from "terriajs-cesium/Source/DataSources/PropertyBag";
import HeightReference from "terriajs-cesium/Source/Scene/HeightReference";
import TerriaFeature from "../Models/Feature/Feature";
import { getFeatureStyle } from "./getFeatureStyle";
export default function createLongitudeLatitudeFeaturePerRow(style) {
  var _style$longitudeColum, _style$latitudeColumn, _style$timeIntervals;
  let longitudes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (_style$longitudeColum = style.longitudeColumn) === null || _style$longitudeColum === void 0 ? void 0 : _style$longitudeColum.valuesAsNumbers.values;
  let latitudes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (_style$latitudeColumn = style.latitudeColumn) === null || _style$latitudeColumn === void 0 ? void 0 : _style$latitudeColumn.valuesAsNumbers.values;
  if (!longitudes || !latitudes) return [];
  const tableColumns = style.tableModel.tableColumns;
  const intervals = style.moreThanOneTimeInterval ? (_style$timeIntervals = style.timeIntervals) !== null && _style$timeIntervals !== void 0 ? _style$timeIntervals : [] : [];
  const rowIds = style.tableModel.rowIds;
  const features = [];
  for (let i = 0; i < rowIds.length; i++) {
    const rowId = rowIds[i];
    const longitude = longitudes[rowId];
    const latitude = latitudes[rowId];
    if (longitude === null || latitude === null) {
      continue;
    }
    const {
      pointGraphicsOptions,
      billboardGraphicsOptions,
      labelGraphicsOptions,
      usePointGraphics
    } = getFeatureStyle(style, rowId);
    const feature = new TerriaFeature({
      position: new ConstantPositionProperty(Cartesian3.fromDegrees(longitude, latitude, 0.0)),
      point: pointGraphicsOptions && usePointGraphics ? new PointGraphics(_objectSpread(_objectSpread({}, pointGraphicsOptions), {}, {
        heightReference: HeightReference.CLAMP_TO_GROUND
      })) : undefined,
      billboard: billboardGraphicsOptions && !usePointGraphics ? new BillboardGraphics(_objectSpread(_objectSpread({}, billboardGraphicsOptions), {}, {
        heightReference: HeightReference.CLAMP_TO_GROUND
      })) : undefined,
      label: labelGraphicsOptions ? new LabelGraphics(_objectSpread(_objectSpread({}, labelGraphicsOptions), {}, {
        heightReference: HeightReference.CLAMP_TO_GROUND
      })) : undefined
      // Note: we don't add path/PathGraphicsOptions here as it is only relevant to time-series (see `createLongitudeLatitudeFeaturePerId.ts`)
    });
    const timeInterval = intervals[rowId];
    if (timeInterval) feature.availability = new TimeIntervalCollection([timeInterval]);
    feature.properties = new PropertyBag(getRowValues(rowId, tableColumns));
    feature.data = {
      rowIds: [rowId],
      type: "terriaFeatureData"
    };
    features.push(feature);
  }
  return features;
}
export function getRowValues(index, tableColumns) {
  const result = {};
  tableColumns.forEach(column => {
    result[column.name] = column.valueFunctionForType(index);
  });
  return result;
}